export const getDescriptionSelector = (state) =>
  state.object?.description?.description;
export const getFloorValueSelector = (state) =>
  state.object?.description?.floorValue;
export const getFloorTotalCountSelector = (state) =>
  state.object?.description?.floorTotalCount;
